import { Spin } from 'antd'
import gifLoading from '../../assets/images/loading_g18.gif'

export default function Loading({ loading }) {
  if (!loading) return null

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        backgroundColor: 'rgba(255,255,255,0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img src={gifLoading} alt="loading" width={80} height={50} />
      {/* hoặc dùng Spin của antd */}
      {/* <Spin size="large" /> */}
    </div>
  )
}
